import React, { useEffect } from 'react';
import { loadUsers } from '@/portal/api';
import { UserData } from '@/portal/types/UserData.ts';
import { useBadgeMultiSelect } from '@/portal/hooks/useBadgeMultiSelect.ts';
import BadgeMultiSelect from '@/portal/components/BadgeMultiSelect.tsx';

interface UserMultiSelectProps {
  selected: UserData[];
  onChange: (updated: UserData[]) => void;
}

const UserMultiSelect: React.FC<UserMultiSelectProps> = ({
  selected,
  onChange,
}) => {
  const { allItems, selectedItems, toggleItem } = useBadgeMultiSelect<UserData>(
    {
      loadAllItems: loadUsers,
      initialSelected: selected,
    }
  );

  useEffect(() => {
    onChange(selectedItems);
  }, [selectedItems, onChange]);

  return (
    <BadgeMultiSelect
      label="Users to notify for patient referrals"
      allItems={allItems}
      selectedItems={selectedItems}
      onToggle={toggleItem}
      getId={(user) => user.id}
      getLabel={(user) => `${user.firstName} ${user.lastName}`}
      badgeClassName="bg-primary"
    />
  );
};

export default UserMultiSelect;
